import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Stack, AppBar, Toolbar, IconButton, Box, Tooltip, Menu, MenuItem, Avatar, ListItemText, Typography } from '@mui/material';
//
import { useSelector, useDispatch } from 'react-redux';
// utils
import { bgBlur } from '../../../utils/cssStyles';
// hooks
import useOffSetTop from '../../../hooks/useOffSetTop';
import useResponsive from '../../../hooks/useResponsive';
// config
import { HEADER } from '../../../config-global';
// components
import Iconify from '../../../components/iconify';
//
import { logout } from '../../../sections/common/redux/actions';
import { PATH_AUTH, PATH_LOGOUT } from '../../../routes/paths';
import { handleError } from '../../../auth/utils';
import UserMasterService from '../../../services/userMaster.service';
import AppCache from '../../../services/appcache';
import HelpService from '../../../services/helpandcommunication.service';
import LogOutModalPopup from '../../../components/ModalPopup/logoutmodalpopup';
import SwitchUserModalPopup from '../../../components/ModalPopup/switchusermodalpopup';
// ------------------------------------------------------------------------------------------------------

COEAdminHeader.propTypes = {
    openNav: PropTypes.bool,
    onOpenNav: PropTypes.func,
    navWidth: PropTypes.number,
};
// ------------------------------------------------------------------------------------------------------

export default function COEAdminHeader({ openNav, onOpenNav, navWidth }) {

    const tooltipSX = { pointerEvents: { xs: 'auto', sm: 'none', }, };
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const theme = useTheme();
    const isDesktop = useResponsive('up', 'lg');
    const isHnCActive = AppCache?.GetCurrentLoggedInUser()?.IsHnCActive;
    // const isOffset = useOffSetTop(HEADER.H_DASHBOARD_DESKTOP);
    const isOffset = useOffSetTop(HEADER.H_DASHBOARD_DESKTOP_NEW);
    // const [headerHeight, setHeaderheight] = useState(HEADER.H_DASHBOARD_DESKTOP);
    const dispatch = useDispatch();
    const loginURL = AppCache.GetLoginURL();
    const [category, setCategory] = useState('');

    const loggedInUser = AppCache?.GetCurrentLoggedInUser();
    const headerToken = AppCache.GetHeaderToken();
    const appToken = loggedInUser.Token;
    const userId = loggedInUser.UserId;
    const primaryUser = AppCache?.GetPrimaryUser()?.CurrentLoggedInUser;
    const impersonAccess = loggedInUser.ImpersonAccess;
    const isImpersonating = loggedInUser.IsImpersonating;

    const [applicationData, setApplicationData] = useState([]);
    const token = sessionStorage.getItem('token');
    const [openLogoutPopup, setLogoutPopup] = useState(false);
    const [openSwitchUserPopup, setSwitchUserPopup] = useState(false);
    const primaryUserName = primaryUser ? `${primaryUser.UserFirstName} ${primaryUser.UserLastName}` : `${loggedInUser.UserFirstName} ${loggedInUser.UserLastName}`;
    const loggedInUserName = `${loggedInUser.UserFirstName} ${loggedInUser.UserLastName}`;

    /*  useEffect(() => {
          if (pathname.split('/')[2] === "data") {
              setHeaderheight(HEADER.H_DATA);
          }
          else {
              setHeaderheight(HEADER.H_DASHBOARD_DESKTOP);
          }
      }, [pathname]); */

    /*  const handleClick = () => {
          AppCache.ClearStorage();
  
          if (loginURL === '/login' || loginURL === '/entlogin') {
              UserMasterService.LogOut()
                  .then((response) => {
                      if (response.status === 200) {
                          navigate(PATH_AUTH.login);
                      }
                      else {
                          // TODO: Handle error and show it to user
                          console.log("error")
                          navigate(PATH_AUTH.login);
                      }
                  })
                  .catch(_error => {
                      //  handleError(_error, navigate, "", "");
                      console.log("error", _error)
                      navigate(PATH_AUTH.login);
                  });
          }
          else {
              dispatch(logout());
              UserMasterService.configFileURL()
                  .then((urlresponse) => {
                      if (urlresponse.status === 200) {
                          const config = JSON.parse(JSON.stringify(urlresponse.data));
                          window.location.href = config.UserMangementUrl;
                      }
                  })
                  .catch((error) => {
                      // Handle error
                      alert("An error occured during logout")
                      // window.location.href = logoutRedirectUrl;
                  });
          }
      };  */

    useEffect(() => {
        const userLoginDetails = AppCache.GetUserLoginDetails();
        const payload = {
            franchise: userLoginDetails?.Franchise,
            region: userLoginDetails?.Region
        }
        HelpService.GetCategories(payload)
            .then((response) => {
                if (response.status === 200) {
                    // setCategory(response.data[0].categoryName);
                    setCategory(response.data[0].category);
                }
                else {
                    // TODO: Handle error and show it to user
                    console.log("error");
                }
            })
            .catch(_error => {
                // handleError(_error, navigate, "", setLoading);
            });
    }, []);

    const handleHelpClick = () => {
        // window.open(PATH_HelpAndCommunication.helpandcommunication("JJ CORE"), "_blank");
        const path = `/helpandcommunication/home/${category}`;
        window.open(path, "_blank");
    }

    useEffect(() => {
        const payload = { UserId: userId, token: appToken }
        UserMasterService.getactiveapplications(payload)
            .then((response) => {
                if (response.status === 200) {
                    setApplicationData(response.data);
                }
                // setLoading(false);
            })
            .catch((error) => {
                // setLoading(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps        
    }, [userId])

    // open application menu
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClickOnAnchor = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    // end

    const getShortName = (name) => name
        .split(/(?=[A-Z])/)        // Split CamelCase
        .map(word => word[0])      // Take first letter
        .join('')
        .toUpperCase();

    const handleGoToHome = (appId) => {
        // UserMasterService.configFileURL().then((urlresponse) => {
        UserMasterService.getProjectUrl().then((urlresponse) => {
            const responseArray = urlresponse.data;

            if (Array.isArray(responseArray) && responseArray.length > 0) {
                const config = responseArray[0]; // Get the first object from the array

                const url = new URL(config.applicationAccessUrl); // Note the camelCase
                url.searchParams.append('userId', userId);
                url.searchParams.append('appToken', headerToken || token);
                url.searchParams.append('appId', appId);

                window.open(url.toString(), '_blank');
            } else {
                console.error('Invalid response format:', urlresponse.data);
            }
        }).catch((error) => {
            console.error('Failed to fetch project URL:', error);
        });
    };

    const handleOpenLogOutPopup = () => {
        setLogoutPopup(true);
    };

    const handleCloseLogOutPopup = () => {
        setLogoutPopup(false);
    };

    console.log("applicationData", applicationData)
    // const isOffset = useOffSetTop(HEADER.H_DASHBOARD_DESKTOP) && !isNavHorizontal;

    const handleClick = () => {
        // const logoutRedirectUrl = `${logoutUrl}`;
        AppCache.ClearStorage();
        dispatch(logout());
        navigate(PATH_LOGOUT.logout)
    };

    const handlelogout = () => {
        handleClick();
    }

    const handleOpenSwitchUserPopup = () => {
        setSwitchUserPopup(true);
    }

    const handleCloseSwitchUserPopup = () => {
        setSwitchUserPopup(false);
    };

    const renderContent = (
        <>
            {!openNav && (
                <IconButton onClick={onOpenNav} sx={{ mr: 1, color: 'text.primary' }}>
                    <Iconify icon="eva:menu-2-fill" />
                </IconButton>
            )}

            <img src='/logo/J&J MedTech Logo.png' alt='' draggable={false} className='JnJMedTechLogo' />

            <Stack
                flexGrow={1}
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
                spacing={{ xs: 0.5, sm: 1 }}
            >
                <Tooltip title={primaryUserName} sx={tooltipSX}>
                    <Box className="PrimaryUserWrapper">
                        <Iconify icon="material-symbols:person-outline" className="PrimaryUserStyle" />
                        <Typography className="PrimaryUserStyle">
                            {primaryUserName}
                        </Typography>
                    </Box>
                </Tooltip>

                {impersonAccess &&
                    <Tooltip title="Switch User" sx={tooltipSX}>
                        <Box className="SwitchUserButton" onClick={handleOpenSwitchUserPopup} sx={{ cursor: 'pointer' }}>
                            <Iconify icon="ic:outline-group" className="PrimaryUserStyle" />
                            <Typography className="PrimaryUserStyle" sx={{ display: { xs: 'none', sm: 'block' } }}> Switch User </Typography>
                        </Box>
                    </Tooltip>
                }

                {isImpersonating &&
                    <Tooltip title={loggedInUserName} sx={tooltipSX}>
                        <Box className="SwitchedUserWrapper" onClick={handleOpenSwitchUserPopup} sx={{ cursor: 'pointer' }}>
                            <Iconify icon="material-symbols:person-outline" className="SwitchedUserStyle" />
                            <Typography className="SwitchedUserStyle" sx={{ display: { xs: 'none', sm: 'block' } }}>
                                {loggedInUserName}
                            </Typography>
                            <IconButton className="SwitchedUserStyle" sx={{ display: { xs: 'none', sm: 'block' } }}>
                                <Iconify icon="material-symbols:arrow-drop-down-rounded" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                }

                {isHnCActive &&
                    <IconButton
                        sx={{
                            width: 40, height: 40, color: '#B50000',
                            ":hover": {
                                cursor: "pointer",
                                color: "#FB0000",
                            },
                        }}
                        onClick={(event) => { handleHelpClick(event); }}
                    >
                        <Iconify icon="carbon:communication-unified" />
                    </IconButton>
                }

                {applicationData.length > 1 &&
                    <div>
                        <Tooltip title="Home">
                            <IconButton
                                sx={{
                                    width: 36,
                                    height: 36,
                                    color: "#B50000",
                                    ":hover": { color: "#FB0000", cursor: "pointer" },
                                }}
                                onClick={handleClickOnAnchor}
                            >
                                <Iconify icon="ic:baseline-apps" />
                            </IconButton>
                        </Tooltip>
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                            PaperProps={{
                                elevation: 4,
                                sx: {
                                    mt: 1,
                                    py: 0.5, // Reduce vertical padding inside menu
                                    minWidth: 180, // Adjust menu width as needed
                                },
                            }}
                            MenuListProps={{
                                dense: true, // reduces item padding
                            }}
                        >
                            {applicationData.filter((app) => app.applicationCode !== "1")
                                .map((app, index) => (
                                    <MenuItem
                                        key={index}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleGoToHome(app.applicationCode);
                                        }}
                                        sx={{
                                            px: 1.5, // horizontal padding
                                            py: 0.7, // vertical padding (reduce height)
                                            "&:hover": {
                                                backgroundColor: "#FFE5E5",
                                                cursor: "pointer",
                                            },
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                            }}
                                        >
                                            <Avatar sx={{ width: 24, height: 24, fontSize: 10 }}>
                                                {getShortName(app.applicationName)}
                                            </Avatar>
                                            <ListItemText
                                                primary={app.applicationName}
                                                primaryTypographyProps={{ color: "#B50000", fontSize: "0.875rem" }} // smaller font
                                            />
                                        </Box>
                                    </MenuItem>
                                ))}
                        </Menu>
                    </div>
                }

                <IconButton
                    sx={{
                        width: 40, height: 40, color: '#B50000',
                        ":hover": {
                            cursor: "pointer",
                            color: "#FB0000",
                        },
                    }}
                    onClick={handleOpenLogOutPopup}
                >
                    <Iconify icon="mdi:shutdown" />
                </IconButton>
            </Stack>

            {openLogoutPopup && <LogOutModalPopup handlelogout={handlelogout} handleCloseLogOutPopup={handleCloseLogOutPopup} />}

            {openSwitchUserPopup && <SwitchUserModalPopup handleOpenSwitchUserPopup={handleOpenSwitchUserPopup}
                handleCloseSwitchUserPopup={handleCloseSwitchUserPopup} />}
        </>
    );

    return (
        <AppBar
            sx={{
                boxShadow: 'none',
                //  height: HEADER.H_MOBILE,
                zIndex: theme.zIndex.appBar + 1,
                ...bgBlur({
                    color: theme.palette.background.default,
                    backgroundColor: theme.palette.background.paper,
                }),
                transition: theme.transitions.create(['height'], {
                    duration: theme.transitions.duration.shorter,
                }),
                ...(isDesktop && {
                    width: `calc(100% - ${navWidth + 1}px)`,
                    // height: headerHeight,
                    height: HEADER.H_DASHBOARD_DESKTOP_NEW,
                    backgroundColor: theme.palette.background.paper,
                    ...(isOffset && {
                        //  height: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
                    }),
                }),
            }}
        >
            <Toolbar
                sx={{
                    //  height: 1,
                    //  px: { lg: 5 },
                }}
            >
                {renderContent}
            </Toolbar>
        </AppBar>
    );
}
